// extracted by mini-css-extract-plugin
module.exports = {"container":"hero_container__7D_qo","containerWide":"hero_containerWide__ulIxz","containerFull":"hero_containerFull__JGBPE","moduleText":"hero_moduleText__iD80g"};